import { all, select, call, fork, put, takeEvery } from "redux-saga/effects";
import { API } from "aws-amplify";

import {
  REQUEST_GET_LIST_RESTAURANT,
  REQUEST_GET_SEATS_AND_SLOTS,
  REQUEST_CREATE_RESTAURANT_CONFIG,
  REQUEST_UPDATE_RESTAURANT_CONFIG,
  REQUEST_GET_RESERVATIONS,
  REQUEST_CREATE_ALACARTE
} from "../actions";

import {
  getRequestRestaurantSuccess,
  getRequestRestaurantError,
  createRestaurantConfigSuccess,
  createRestaurantConfigError,
  updateRestaurantConfigSuccess,
  updateRestaurantConfigError,
  getSeatsAndSlotsRestaurantSuccess,
  getSeatsAndSlotsRestaurantError,
  getReservationsSuccess,
  getReservationsError,
  createAlacarteRequestSuccess,
  createAlacarteRequestError
} from "./actions";

// import requestData from '../../data/requests.json';

const REQUESTS_BASE = "/requests";
const CREATE_CONFIG = "/requests/alacarteConfig";
const UPDATE_CONFIG = "/requests/alacarteConfig";
const GET_CONFIG = "/requests/alacarteConfig";
const RESTAURANT_BASE = "/hotels/restaurants";

export const getHotelRestaurantAsync = async hotel_id => {
  const apiName = "WebeeAPI";
  const path = GET_CONFIG;
  const myInit = {
    queryStringParameters: {
      hotel_id
    }
  };
  try {
    const result = await API.get(apiName, path, myInit);
    return result;
  } catch (err) {
    // console.error('get hotel restaurant error in async', err);
    throw err;
  }
};

export const getSeatsAndSlotsAsync = async payload => {
  const apiName = "WebeeAPI";
  const path = RESTAURANT_BASE;
  const myInit = {
    queryStringParameters: {
      hotel_id: payload.hotel_id,
      restaurant_id: payload.restaurant_id
    }
  };
  try {
    const result = await API.get(apiName, path, myInit);
    return result;
  } catch (err) {
    // console.error('get seats and slots restaurant error in async', err);
    throw err;
  }
};

export const getReservationsAsync = async payload => {
  const apiName = "WebeeAPI";
  const path = `${REQUESTS_BASE}`;
  const myInit = {
    queryStringParameters: {
      hotel_id: payload.hotel_id,
      reservation_id: payload.reservation_id
    }
  };
  try {
    const result = await API.get(apiName, path, myInit);
    return result;
  } catch (err) {
    // console.error('get reservations error in async', err);
    throw err;
  }
};

export const createRestaurantConfigAsync = async payload => {
  const apiName = "WebeeAPI";
  const path = CREATE_CONFIG;
  const myInit = {
    body: payload
  };
  try {
    const result = await API.post(apiName, path, myInit);
    return result;
  } catch (err) {
    // console.error('Create config error in async', err);
    throw err;
  }
};

export const createAlacarteRequestAsync = async payload => {
  const apiName = "WebeeAPI";
  const path = REQUESTS_BASE;
  const myInit = {
    body: payload
  };
  try {
    const result = await API.post(apiName, path, myInit);
    return result;
  } catch (err) {
    // console.error('Create alacarte request error in async', err);
    throw err;
  }
};

export const updateRestaurantConfigAsync = async payload => {
  const apiName = "WebeeAPI";
  const alacarteConfigId = payload.id;
  const path = `${UPDATE_CONFIG}/${alacarteConfigId}`;
  try {
    const result = await API.patch(apiName, path, { body: payload.config });
    return result;
  } catch (err) {
    // console.error('update config error in async', err);
    throw err;
  }
};

export function* getHotelRestaurant({ payload }) {
  try {
    const state = yield select();
    const { hotelId } = state.settings.hotelConfig;
    const response = yield call(getHotelRestaurantAsync, hotelId);
    if (response) {
      yield put(getRequestRestaurantSuccess(response));
    } else {
      yield put(getRequestRestaurantSuccess("No restaurant Config or restaurants visible false"));
    }
  } catch (error) {
    // console.error('get hotel restaurant error:', error);
    yield put(getRequestRestaurantError({ error }));
  }
}

export function* watchGetHotelRestaurant() {
  yield takeEvery(REQUEST_GET_LIST_RESTAURANT, getHotelRestaurant);
}

export function* getSeatsAndSlotsRestaurant({ payload }) {
  try {
    // const state = yield select();
    const response = yield call(getSeatsAndSlotsAsync, payload);
    yield put(getSeatsAndSlotsRestaurantSuccess(response));
  } catch (error) {
    // console.error('get seats and slots restaurant error:', error);
    yield put(getSeatsAndSlotsRestaurantError({ error }));
  }
}

export function* watchGetSeatsAndSlotsRestaurant() {
  yield takeEvery(REQUEST_GET_SEATS_AND_SLOTS, getSeatsAndSlotsRestaurant);
}

export function* getReservations({ payload }) {
  try {
    // const state = yield select();
    const response = yield call(getReservationsAsync, payload);
    yield put(getReservationsSuccess(response));
  } catch (error) {
    // console.error('get reservations restaurant error:', error);
    yield put(getReservationsError({ error }));
  }
}

export function* watchGetReservations() {
  yield takeEvery(REQUEST_GET_RESERVATIONS, getReservations);
}

export function* createRestaurantConfig({ payload }) {
  try {
    const response = yield call(createRestaurantConfigAsync, payload);
    yield put(createRestaurantConfigSuccess(response));
  } catch (error) {
    // console.error('Create config error:', error);
    yield put(createRestaurantConfigError({ error }));
  }
}

export function* watchCreateConfig() {
  yield takeEvery(REQUEST_CREATE_RESTAURANT_CONFIG, createRestaurantConfig);
}

export function* createAlacarteRequest({ payload }) {
  try {
    const response = yield call(createAlacarteRequestAsync, payload);
    yield put(createAlacarteRequestSuccess(response));
  } catch (error) {
    // console.error('Create config error:', error);
    yield put(createAlacarteRequestError({ error }));
  }
}

export function* watchCreateRequest() {
  yield takeEvery(REQUEST_CREATE_ALACARTE, createAlacarteRequest);
}

export function* updateRestaurantConfig({ payload }) {
  try {
    const response = yield call(updateRestaurantConfigAsync, payload);
    yield put(updateRestaurantConfigSuccess(response));
  } catch (error) {
    // console.error('update config error:', error);
    yield put(updateRestaurantConfigError({ error }));
  }
}

export function* watchUpdateConfig() {
  yield takeEvery(REQUEST_UPDATE_RESTAURANT_CONFIG, updateRestaurantConfig);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetHotelRestaurant),
    fork(watchCreateConfig),
    fork(watchUpdateConfig),
    fork(watchGetSeatsAndSlotsRestaurant),
    fork(watchGetReservations),
    fork(watchCreateRequest)
  ]);
}
